module.exports = __webpack_public_path__ + "img/start-scan.ff96f45d.svg";